import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';

export enum LogLevel {
  Debug,
  Info,
  Warning,
  Error,
}

type LogFunction = (...arg: any[]) => void;

class Logger {
  constructor(private service: LoggerService, private name: string) {
  }

  debug(msg: string, ...args: any[]) {
    this.log(LogLevel.Debug, console.debug, msg, args);
  }

  info(msg: string, ...args: any[]) {
    this.log(LogLevel.Info, console.info, msg, args);
  }

  warn(msg: string, ...args: any[]) {
    this.log(LogLevel.Warning, console.warn, msg, args);
  }

  error(msg: string, ...args: any[]) {
    this.log(LogLevel.Error, console.error, msg, args);
  }

  private log(level: LogLevel, fn: LogFunction, msg: string,  args: any[]) {
    if (this.service.isLevel(this.name, level)) {
      fn(`[${this.name}] ${msg}`, ...args)
    }
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private level: LogLevel = environment.logLevel || LogLevel.Info;
  private namedLevels: Record<string, LogLevel> = {}

  constructor() {
    (window as any)['appLogging'] = this
  }

  get(name: string): Logger {
    return new Logger(this, name)
  }

  setLevel(level: LogLevel): void
  setLevel(name: string, level: LogLevel): void
  setLevel(p1: string | LogLevel, p2?: LogLevel): void {
    if (p2) {
      this.namedLevels[p1] = p2
    } else {
      this.level = p1 as LogLevel
    }
  }

  getLevel(name?: string): LogLevel {
    if (name) {
      return this.namedLevels[name] || this.level
    }
    return this.level
  }

  isLevel(level: LogLevel): boolean
  isLevel(name: string, level: LogLevel): boolean
  isLevel(p1: string | LogLevel, p2?: LogLevel): boolean {
    if (typeof p1 === 'string') {
      return this.getLevel(p1) >= p2!
    } else {
      return this.getLevel() >= p1
    }
  }
}
